// 支付来源originSystemId
export var PAY_ORIGIN_SYSTEM_ID = 5;